import React, { Component } from "react";
import styled from "styled-components";
import baseStyles from "../../styles/baseStyles";
import InfoCardCarousel from "../InfoCardCarousel";
import Map from "../Map";

const Wrapper = styled.section`
  max-width: 64rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;
  text-align: center;
  position: relative;
`;

const Title = styled.h2`
  text-transform: uppercase;
  font-family: Poppins;
  letter-spacing: 0.1em;
  font-size: 2.25rem;
  margin-bottom: 1rem;
`;

const TitleDark = Title.extend`
  color: ${baseStyles.color.darkGray};
  text-align: center;
  margin-bottom: 8rem;
`;

export class MapSection extends Component {
  state = {
    selectedCountryIndex: 0
  };

  onSelectCountry = countryName => {
    const selectedCountryIndex = this.props.countries.findIndex(
      country => country.name === countryName
    );

    if (selectedCountryIndex >= 0) {
      this.setState({
        selectedCountryIndex
      });
    }
  };

  onCountryChange = newIndex => {
    const length = this.props.countries.length;
    if (newIndex === length) {
      this.setState({
        selectedCountryIndex: 0
      });
    } else if (newIndex < 0) {
      this.setState({
        selectedCountryIndex: length - 1
      });
    } else {
      this.setState({
        selectedCountryIndex: newIndex
      });
    }
  };

  render() {
    return (
      <Wrapper>
        <TitleDark>Nordics</TitleDark>
        <InfoCardCarousel
          selectedCountryIndex={this.state.selectedCountryIndex}
          countries={this.props.countries}
          onCountryChange={this.onCountryChange}
        />
        <Map
          selectedCountry={
            this.props.countries[this.state.selectedCountryIndex].name
          }
          onSelectCountry={this.onSelectCountry}
        />
      </Wrapper>
    );
  }
}

export default MapSection;



// WEBPACK FOOTER //
// ./src/components/MapSection/index.js